import { Button } from '@seen/ui'
import { forwardRef } from 'react'
import { Avatar } from '#src/components/core/Avatar/Avatar.tsx'
import { Combobox } from '#src/components/core/combobox/Combobox.tsx'
import type { Field } from '#src/components/core/form/FormField.tsx'
import { IconUserPlaceholder } from '#src/components/icons/IconUserPlaceholder.tsx'
import { useOwnerComboboxOptions } from '#src/components/UseOwnerComboboxOptions.tsx'

export const OwnerIconCombobox = forwardRef<
  HTMLButtonElement,
  Field<string | null>
>(({ value, onChange, ...fieldRest }, ref) => {
  const options = useOwnerComboboxOptions(value)
  return (
    <Combobox options={options} onSelect={onChange}>
      <Button
        variant="unstyled"
        className="h-full p-0 hover:brightness-hover-icon data-[state=open]:brightness-hover-icon"
        ref={ref}
        {...fieldRest}
      >
        {value && <Avatar profile={{ reference: value }} size="icon" />}
        {!value && (
          <IconUserPlaceholder className="text-foreground-secondary" />
        )}
      </Button>
    </Combobox>
  )
})
OwnerIconCombobox.displayName = 'OwnerCombobox'
